// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

const INCOMING_DOCUMENT_BASE_URL = '/api/v1/wechat/incoming-document';

/**
 * 获取收文审批流程列表
 * @param params 查询参数
 * @param options 请求配置
 */
export async function getIncomingDocumentApplicationList(
  params?: OA.IncomingDocumentApplicationListParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.IncomingDocumentApplicationListData>>(
    `${INCOMING_DOCUMENT_BASE_URL}/applications`,
    {
      method: 'GET',
      params: params || {},
      ...(options || {}),
    },
  );
}

/**
 * 获取收文审批详情
 * @param sp_no 审批单号
 * @param options 请求配置
 */
export async function getIncomingDocumentDetail(
  sp_no: string,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.IncomingDocumentDetail>>(
    `${INCOMING_DOCUMENT_BASE_URL}/detail/${sp_no}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 发起收文传阅
 * @param sp_no 审批单号
 * @param data 传阅参数
 * @param options 请求配置
 */
export async function circulateIncomingDocument(
  sp_no: string,
  data: OA.CirculateIncomingDocumentParams,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.CirculateIncomingDocumentResponse>>(
    `${INCOMING_DOCUMENT_BASE_URL}/circulate/${sp_no}`,
    {
      method: 'POST',
      data,
      ...(options || {}),
    },
  );
}

/**
 * 获取收文传阅记录
 * @param sp_no 审批单号
 * @param options 请求配置
 */
export async function getIncomingDocumentCirculations(
  sp_no: string,
  options?: { [key: string]: any },
) {
  return request<OA.ApiResponse<OA.CirculationRecord[]>>(
    `${INCOMING_DOCUMENT_BASE_URL}/circulations/${sp_no}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/**
 * 导出收文办文单
 * @param sp_no 审批单号
 */
export async function exportIncomingDocument(sp_no: string) {
  return request(`${INCOMING_DOCUMENT_BASE_URL}/export/${sp_no}`, {
    method: 'GET',
    responseType: 'blob',
  });
}

